import { resourceReducer } from '../../utils/resourceReducer';

// Create actions and a reducer for the tradeOrders resource
export const [actions, reducer, resourceSagas] = resourceReducer('trade-orders');

export const sagas = resourceSagas;
